// V-P1 · Shared lifecycle/status pill helper.
// Deterministic mapping from existing project/estimate/proposal/
// contract/invoice status values into the consistent jc-pill-* CSS
// classes declared in index.css. Used across Dashboard Active Jobs,
// Customers landing, Projects landing, and Project Connected View so
// the same lifecycle stage never renders in different colors on
// different surfaces.
//
// STRICT: this helper reads existing status strings only. It does NOT
// introduce new lifecycle states, health scores, priority scores,
// hidden AI classification, or any speculative categorization.
import React from "react";

const PROJECT_KIND = {
  draft: { cls: "jc-pill-draft", labelKey: "status.draft" },
  active: { cls: "jc-pill-progress", labelKey: "status.active" },
  in_progress: { cls: "jc-pill-progress", labelKey: "status.in_progress" },
  scheduled: { cls: "jc-pill-approved", labelKey: "status.scheduled" },
  completed: { cls: "jc-pill-complete", labelKey: "status.completed" },
  complete: { cls: "jc-pill-complete", labelKey: "status.completed" },
  archived: { cls: "jc-pill-archived", labelKey: "status.archived" },
};

const ESTIMATE_KIND = {
  draft: { cls: "jc-pill-draft", labelKey: "status.draft" },
  sent: { cls: "jc-pill-sent", labelKey: "status.sent" },
  approved: { cls: "jc-pill-approved", labelKey: "status.approved" },
  declined: { cls: "jc-pill-archived", labelKey: "status.declined" },
};

const CONTRACT_KIND = {
  draft: { cls: "jc-pill-draft", labelKey: "status.draft" },
  sent: { cls: "jc-pill-sent", labelKey: "status.sent" },
  awaiting_signature: { cls: "jc-pill-sent", labelKey: "status.awaiting_signature" },
  signed: { cls: "jc-pill-signed", labelKey: "status.signed" },
};

const INVOICE_KIND = {
  draft: { cls: "jc-pill-draft", labelKey: "status.draft" },
  sent: { cls: "jc-pill-unpaid", labelKey: "status.unpaid" },
  paid: { cls: "jc-pill-paid", labelKey: "status.paid" },
  partial: { cls: "jc-pill-partial", labelKey: "status.partial" },
  overdue: { cls: "jc-pill-unpaid", labelKey: "status.overdue" },
};

const KINDS = {
  project: PROJECT_KIND,
  estimate: ESTIMATE_KIND,
  contract: CONTRACT_KIND,
  invoice: INVOICE_KIND,
};

export function StatusPill({ status, kind = "project", t, className = "" }) {
  const map = KINDS[kind] || PROJECT_KIND;
  const entry = map[status] || { cls: "jc-pill-neutral", labelKey: null };
  const label =
    (entry.labelKey && t && t(entry.labelKey)) ||
    (status ? status.replace(/_/g, " ") : "—");
  return (
    <span
      className={`jc-pill ${entry.cls} ${className}`}
      data-testid={`status-pill-${kind}-${status || "unknown"}`}
    >
      <span className="jc-pill-dot" />
      {label}
    </span>
  );
}

export default StatusPill;
